/**
 * @generated SignedSource<<131bf1ca353d72d08ac46cf348a737ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SetDefaultPaymentMethodDialog_paymentMethod$data = {
  readonly cardBrand: string | null | undefined;
  readonly id: string;
  readonly lastFourDigits: string | null | undefined;
  readonly paymentMethodType: string;
  readonly " $fragmentType": "SetDefaultPaymentMethodDialog_paymentMethod";
};
export type SetDefaultPaymentMethodDialog_paymentMethod$key = {
  readonly " $data"?: SetDefaultPaymentMethodDialog_paymentMethod$data;
  readonly " $fragmentSpreads": FragmentRefs<"SetDefaultPaymentMethodDialog_paymentMethod">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SetDefaultPaymentMethodDialog_paymentMethod",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paymentMethodType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "cardBrand",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastFourDigits",
      "storageKey": null
    }
  ],
  "type": "PaymentMethod",
  "abstractKey": null
};

(node as any).hash = "3cc3c9b0021ed90a835bdf812c9faabd";

export default node;
